// extracted by mini-css-extract-plugin
module.exports = {"ReservationsPage":"ReservationsPage_ReservationsPage__2Ypnn","ReservationsPage__Welcome":"ReservationsPage_ReservationsPage__Welcome__yosYJ"};